import { combineReducers } from "redux";

import keplerGlReducer from "kepler.gl/reducers";


// Front
import LayoutReducer from "./layouts/Reducer";

// authentication
import LoginReducer from "./auth/login/Reducer";
import AccountReducer from "./auth/register/Reducer";
import ProfileReducer from "./auth/profile/Reducer";
import veloxityFindDevicesSlice from "./veloxity/profile/FindDevicesReducer";
import veloxityGetAudienceGenderSlice from './veloxity/audience/GenderReducer';
import veloxityGetAudienceInAppSlice from './veloxity/audience/InAppReducer';
import veloxityGetAudienceGenerationSlice from './veloxity/audience/GenerationReducer';
import veloxityGetAudienceInterestsSlice from "./veloxity/audience/InterestReducer";
import veloxityGetAudienceLocationsSlice from "./veloxity/audience/LocationReducer";
import veloxityGetAudiencePurhasingSlice from "./veloxity/audience/PurchasingPowerReducer";
import veloxityGetAudienceOSSlice from "./veloxity/audience/OsReducer";
import veloxityGetAudienceSalesSlice from "./veloxity/audience/SalesPredictionReducer";
import veloxityForgotPasswordReducer from "./veloxity/auth/ForgotPasswordReducer";
import veloxityGetProductsSlice from "./veloxity/audience/GetProductsReducer";

import filterReducer from "./veloxity/profile/FilterReducer";
import profileTypes from "./veloxity/profile/ProfileTypeReducer";

import demographicReducer from "./veloxity/profile/DemographicReducer"
import loginTestReducer from "./veloxity/auth/LoginReducer"
import inAppReducer from "./veloxity/profile/InAppReducer"
import salesPredictionReducer from "./veloxity/profile/SalesPredictionReducer"
import InterestReducer from "./veloxity/profile/InterestReducer";
import profileCommentReducer from "./veloxity/profile/ProfileCommentReducer";

import findAllAudienceReducer from "./veloxity/audience/FindAllAudienceReducer";
import topProfileTypesSlice from "./veloxity/audience/TopProfileTypesReducer";
import veloxityGetAudienceAnalysisSlice from "./veloxity/audience/AnalysisReducer";

import audienceCreateSlice  from "./veloxity/audience/CreateReducer";
import deleteAudienceSlice from "./veloxity/audience/DeleteRedujer";
import audienceDefineCreateSlice  from "./veloxity/audience/CreateDefineReducer";
import reportDownloadSlice  from "./veloxity/audience/ReportReducer";
import veloxityGetReportInfoSlice  from "./veloxity/audience/ReportInfoReducer";
import loginSlice  from "./veloxity/auth/LoginReducer";
import changePasswordSlice  from "./veloxity/auth/ChangePasswordReducer";
import veloxityGetCsvInfoSlice  from "./veloxity/audience/CsvInfoReducer";
import downloadCsvPlanSlice  from "./veloxity/audience/CsvDownloadReducer";
import getAudienceDefinitionConfig  from "./veloxity/audience/DefineConfigReducer";
import getAudienceSelectionConfig  from "./veloxity/audience/SelectionConfigReducer";
import audienceDefinePreviewSlice from "./veloxity/audience/CreateAudienceDefinePreview"; 
import audiencePreviewSlice from './veloxity/audience/CreateAudiencePreview';
import veloxityResetPasswordSlice from './veloxity/auth/ResetPasswordReducer'
import getVeloxityAudienceLocationHeat  from "./veloxity/audience/LocationHeatReducer";
import authSlice from './veloxity/auth/RefleshToken'; 

// Client 
import getClientListSlice  from "./veloxity/client/ClientListReducer";
import updateClientSlice from "./veloxity/client/ClientUpdateReducer";
import createClientSlice from "./veloxity/client/ClientCreateReducer"; 
import deleteClientSlice from "./veloxity/client/ClientDeleteReducer";
import addClientLicenseSlice from './veloxity/client/ClientAddLicenseKey';
import removeClientLicenseSlice from './veloxity/client/ClientRemoveLicenseKey';
import clientStatusUpdateSlice from './veloxity/client/ClientStatusUpdate';

// Client User 
import getClientUserListSlice from "./veloxity/client/ClientUserListReducer";
import createClientUserSlice  from "./veloxity/client/ClientUserCreateReducer";
import updateClientUserSlice from "./veloxity/client/ClientUserUpdateReducer";
import deleteClientUserSlice from "./veloxity/client/ClientDeleteReducer";
import registerPasswordSlice     from "./veloxity/client/ClientUserRegisterPasswordReducer";
import convertTargetAudienceSlice from "./veloxity/audience/ConvertTargetAudience";

// Ooh
import getOohListSlice  from "./veloxity/ooh/OohListReducer";
import createOohAudienceSlice  from "./veloxity/ooh/OohCreateReducer";
import deleteOohAudienceSlice  from "./veloxity/ooh/OohDeleteReducer";

// Target Audience
import getAllTargetAudience from "./veloxity/targetAudience/getAllTargetAudience";
import createTargetManualy from "./veloxity/targetAudience/createTargetManualy";
import recalculateTargetAudience from "./veloxity/audience/RecalculateTargetReducer";
import createTargetDefineAudience from "./veloxity/targetAudience/createTargetDefineAudience";

// Integration
import adformS3ValidationSlice from "./veloxity/integration/adformS3ValidationSlice";
import googleAdsValidationSlice from "./veloxity/integration/googleAdsValidationSlice";
import fetchConfigsSlice from "./veloxity/integration/fetchConfigsSlice";
import deleteConfigReducer from './veloxity/integration/deleteConfigSlice';
import updateConfigReducer from './veloxity/integration/updateConfigSlice';
import createConfigSlice from "./veloxity/integration/createConfigSlice";
import createExportAdformSlice from "./veloxity/integration/export/createExportAdform";
import getExportPlansSlice from "./veloxity/integration/export/getExportPlans";
import createExportFacebookSlice from "./veloxity/integration/export/createExportFacebook";
import createExportGoogleSlice from "./veloxity/integration/export/createExportGoogle"
import createTiktokAdSlice from "./veloxity/integration/export/createTiktokAd";

// Permissions
import  getPermissionsListSlice  from "./veloxity/auth/permissionsManagement/getPermissionList";
import  getSubscriptionListSlice  from "./veloxity/auth/permissionsManagement/getSubscriptionList";
import  updateSubscriptionSlice  from "./veloxity/auth/permissionsManagement/updateSubscription";
import  enableDisableSubscriptionSlice  from "./veloxity/auth/permissionsManagement/enableDisableSubscription";

//Lookalike
import lookalikeReducer from "./veloxity/audience/LookalikeAudienceReducer";

// Admin Analytics
import getLicensesListSlice from "./veloxity/adminAnalytics/getLicensesList";
import getDataTypeAnalyticsSlice from "./veloxity/adminAnalytics/getDataTypeAnalyticsSlice";
import getInstallDeviceAnalyticsSlice from "./veloxity/adminAnalytics/getInstallDeviceAnalyticsSlice";
import getDailySessionAnalyticsSlice from "./veloxity/adminAnalytics/getDailySessionAnalyticsSlice";
import getTotalAppUserAnalyticSlice from "./veloxity/adminAnalytics/getTotalAppUserAnalyticSlice";
import chatReducer from "./veloxity/adminAnalytics/chatReducer";


// Push Notification
import createApplicationSlice  from "./veloxity/pushNotification/createApplication";
import listApplicationsSlice  from "./veloxity/pushNotification/listApplication";
import deleteApplicationSlice  from "./veloxity/pushNotification/deleteApplication";
import sendMessageSlice from "./veloxity/pushNotification/sendMessage";
import sendSilentMesageSlice from "./veloxity/pushNotification/sendSilentMessage";
import listCampaignsSlice from "./veloxity/pushNotification/listCampaigns";
import campaignActionsSlice from "./veloxity/pushNotification/campaignActions";

import bitcoinPredictionReducer from "./veloxity/bitcoin/BitcoinPredictionReducer";

import getClientImagesReducer from "./veloxity/pushNotification/getClientImages";
import uploadImageReducer from "./veloxity/pushNotification/uploadImage";

const customizedKeplerReducer = keplerGlReducer.initialState({
  uiState: {
    activeSidePanel: null, // Varsayılan olarak yan paneli kapat
    currentModal: null, // Varsayılan olarak modal kapalı
  },
});

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,

  Profile: ProfileReducer,
  VeloxityFindDevices: veloxityFindDevicesSlice,
  audienceGender: veloxityGetAudienceGenderSlice,
  audienceInApp: veloxityGetAudienceInAppSlice,
  audienceGeneration: veloxityGetAudienceGenerationSlice,
  audienceLocations: veloxityGetAudienceLocationsSlice,
  audiencePurchasing: veloxityGetAudiencePurhasingSlice,
  audienceInterests: veloxityGetAudienceInterestsSlice,
  audienceSalesPrediction: veloxityGetAudienceSalesSlice,
  audienceOS: veloxityGetAudienceOSSlice,
  demographic: demographicReducer,
  loginTest: loginTestReducer,
  inApp: inAppReducer,
  salesPrediction: salesPredictionReducer,
  interests: InterestReducer,
  profileComment: profileCommentReducer,
  filterDevice: filterReducer,
  profileTypes: profileTypes,
  findAllAudienceReducer: findAllAudienceReducer,
  topProfileTypes: topProfileTypesSlice,
  audienceAnalysis: veloxityGetAudienceAnalysisSlice,
  audienceCreate: audienceCreateSlice,
  defineAudienceCreate: audienceDefineCreateSlice,
  deleteAudience: deleteAudienceSlice,
  reportDownload: reportDownloadSlice,
  reportInfo: veloxityGetReportInfoSlice,
  csvInfo: veloxityGetCsvInfoSlice,
  csvDownload: downloadCsvPlanSlice,
  loginSlice: loginSlice,
  selectionConfig: getAudienceSelectionConfig,
  defineConfig: getAudienceDefinitionConfig,
  audienceDefinePreview: audienceDefinePreviewSlice,
  audiencePreview: audiencePreviewSlice,
  authSlice: authSlice,
  ForgotPassword: veloxityForgotPasswordReducer,
  resetPassword: veloxityResetPasswordSlice,
  clientList: getClientListSlice,
  updateClient: updateClientSlice,
  createClient: createClientSlice,
  deleteClient: deleteClientSlice,
  changePassword: changePasswordSlice,
  clientUserList: getClientUserListSlice,
  createClientUser: createClientUserSlice,
  deleteClientUser: deleteClientUserSlice,
  updateClientUser: updateClientUserSlice,
  registerPassword :registerPasswordSlice,
  oohList: getOohListSlice,
  createOohAudience: createOohAudienceSlice,
  deleteOohAudience: deleteOohAudienceSlice,
  targetAllAudience: getAllTargetAudience,
  createTargetManualy: createTargetManualy,
  adformS3Validation: adformS3ValidationSlice,
  createTiktokAd: createTiktokAdSlice,
  googleAdsValidation: googleAdsValidationSlice,
  fetchConfigs: fetchConfigsSlice,
  deleteConfig: deleteConfigReducer,
  updateConfig: updateConfigReducer,
  createConfig: createConfigSlice,
  addClientLicense: addClientLicenseSlice,
  removeClientLicense: removeClientLicenseSlice,
  clientStatusUpdate:clientStatusUpdateSlice,
  getPermissionsList : getPermissionsListSlice,
  getSubscriptionList : getSubscriptionListSlice,
  updateSubscription : updateSubscriptionSlice,
  enableDisableSubscription : enableDisableSubscriptionSlice,
  recalculateTargetAudience: recalculateTargetAudience,
  createTargetDefineAudience: createTargetDefineAudience,
  createExportAdform: createExportAdformSlice,
  getExportPlans: getExportPlansSlice,
  createExportFacebook: createExportFacebookSlice,
  createExportGoogle: createExportGoogleSlice,
  convertTargetAudience: convertTargetAudienceSlice,
  lookalike: lookalikeReducer,
  getProducts: veloxityGetProductsSlice,
  getLicensesList: getLicensesListSlice,
  dataTypeAnalytics: getDataTypeAnalyticsSlice,
  installDeviceAnalytics: getInstallDeviceAnalyticsSlice,
  dailySessionAnalytics: getDailySessionAnalyticsSlice,
  totalAppUserAnalytics:getTotalAppUserAnalyticSlice,
  locationHeat: getVeloxityAudienceLocationHeat,
  chat: chatReducer,
  keplerGl: customizedKeplerReducer,
  createApplication: createApplicationSlice,
  listApplications: listApplicationsSlice,
  deleteApplication: deleteApplicationSlice,
  sendMessage: sendMessageSlice,
  sendSilentMessage: sendSilentMesageSlice,
  listCampaigns: listCampaignsSlice,
  campaignActions: campaignActionsSlice,
  bitcoinPrediction: bitcoinPredictionReducer,
  getClientImages: getClientImagesReducer,
  uploadImage: uploadImageReducer,
});

export default rootReducer;
